import React, { useCallback, useEffect, useState } from "react";
import { req } from "../api";

export default function InvoiceHistory() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const qs = new URLSearchParams();
      qs.set("page", String(page));
      qs.set("limit", "20");
      if (status) qs.set("status", status);

      const out = await req(`/api/user/invoices/list?${qs.toString()}`);
      if (out.json?.ok) {
        setItems(out.json.items || []);
        setTotal(out.json.total || 0);
      } else {
        setItems([]);
        setTotal(0);
      }
    } finally {
      setLoading(false);
    }
  }, [page, status]);

  useEffect(() => {
    load().catch(() => {});
  }, [load]);

  const pages = Math.max(1, Math.ceil(total / 20));

  return (
    <div style={{ padding: 16 }}>
      <h2>Invoice history</h2>

      <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 12 }}>
        <label>Status:</label>
        <select
          value={status}
          onChange={(e) => {
            setPage(1);
            setStatus(e.target.value);
          }}
          disabled={loading}
        >
          <option value="">All</option>
          <option value="created">created</option>
          <option value="pending">pending</option>
          <option value="paid">paid</option>
          <option value="expired">expired</option>
          <option value="canceled">canceled</option>
          <option value="failed">failed</option>
        </select>

        <div style={{ marginLeft: "auto" }}>
          <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={loading || page <= 1}>
            Prev
          </button>
          <span style={{ padding: "0 8px" }}>
            {page} / {pages}
          </span>
          <button onClick={() => setPage((p) => Math.min(pages, p + 1))} disabled={loading || page >= pages}>
            Next
          </button>
        </div>
      </div>

      <div style={{ opacity: loading ? 0.6 : 1 }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Created</th>
              <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>OrderId</th>
              <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Route</th>
              <th style={{ textAlign: "right", borderBottom: "1px solid #ddd", padding: 8 }}>Amount</th>
              <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((x) => (
              <tr key={x._id}>
                <td style={{ borderBottom: "1px solid #f0f0f0", padding: 8 }}>
                  {x.createdAt ? new Date(x.createdAt).toLocaleString() : "-"}
                </td>
                <td style={{ borderBottom: "1px solid #f0f0f0", padding: 8 }}>{x.potemeOrderId || "-"}</td>
                <td style={{ borderBottom: "1px solid #f0f0f0", padding: 8 }}>{x.routeId || "-"}</td>
                <td style={{ borderBottom: "1px solid #f0f0f0", padding: 8, textAlign: "right" }}>
                  {String(x.amount ?? "")}
                </td>
                <td style={{ borderBottom: "1px solid #f0f0f0", padding: 8 }}>{x.status || "-"}</td>
              </tr>
            ))}

            {!loading && items.length === 0 && (
              <tr>
                <td colSpan={5} style={{ padding: 16, color: "#777" }}>
                  No invoices
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
